var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBriefcase1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "briefcase_1_",
    "data-name": "briefcase (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.984,
    height: 18.272,
    viewBox: "0 0 20.984 18.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73708",
    "data-name": "Group 73708",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90713",
    "data-name": "Path 90713",
    d: "M14.253,36.362a3.8,3.8,0,0,0-7.522,0H0V51.353H20.984V36.362Zm-3.761-2.052a2.571,2.571,0,0,1,2.515,2.052H7.977A2.571,2.571,0,0,1,10.492,34.311Zm9.231,3.281a6.069,6.069,0,0,1-6.03,5.446h-.743v-1.23H8.033v1.23H7.29a6.069,6.069,0,0,1-6.03-5.446Zm-8,5.445v1.231H9.262V43.037Zm8.033,7.087H1.23v-9.1A7.289,7.289,0,0,0,7.29,44.267h.743V45.5h4.918v-1.23h.743a7.289,7.289,0,0,0,6.061-3.243Z",
    transform: "translate(0 -33.081)",
    fill: "#a6a6a6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase1);
export default __webpack_public_path__ + "static/media/briefcase (1).0bd6157b38c780f637ea4a105f8143c8.svg";
export { ForwardRef as ReactComponent };